import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';

// Subscription levels:
// NONE - free user
// BASIC - low tier user
// PRO - high tier user

export function getUserDetails(sessionId) {
    return dispatch => {
        dispatch(userDetailFetching());

        const service = new FantasyLabsService();
        service.getUserDetails(
            sessionId,
            err => dispatch(userDetailFailed(err)),
            json => dispatch(userDetailSuccess(json))
        );
    };
}

function userDetailFetching() {
    return {
        type: actionTypes.USER_DETAILS_FETCHING
    };
}

function userDetailSuccess(json) {
    return {
        type: actionTypes.USER_DETAILS_SUCCESS,
        results: json === null ? [] : json
    };
}

function userDetailFailed(err) {
    return {
        type: actionTypes.USER_DETAILS_FAILED,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/userDetails.js